import React from "react";
import { Grid, Typography } from "@mui/material";

import {
  ControlledFormDesktopDatePicker,
  ControlledFormDateTime,
  ControlledFormEditor,
  ControlledFormInput,
  ControlledFormSelect,
  ControlledFormSwitch,
} from "../index";
const FormGrid = ({
  disablePlaceholder,
  control,
  getValues,
  id,
  label,
  name,
  objectType,
  type,
  options = [],
  ...props
}) => {
  const inRules = props?.rules;
  const gridProps = {
    xs: type === "text" && !props?.rules?.maxLength ? 12 : "auto",
  };
  return (
    <Grid item key={`${id}-${name}.grid`} {...gridProps}>
      {type === "date" && (
        <ControlledFormDesktopDatePicker
          {...props}
          control={control}
          id={id}
          label={label}
          name={name}
        />
      )}
      {type === "datetime" && (
        <ControlledFormDateTime
          {...props}
          control={control}
          id={id}
          label={label}
          name={name}
        />
      )}
      {type === "editor" && (
        <>
          <Typography variant="subtitle1">{label}</Typography>
          <ControlledFormEditor
            {...props}
            control={control}
            id={id}
            name={name}
          />
        </>
      )}
      {type === "integer" && (
        <ControlledFormInput
          {...props}
          control={control}
          id={id}
          label={label}
          multiline={false}
          name={name}
          rules={{
            pattern: {
              message: "This field must contain a valid number",
              value: /^\d+$/,
            },
            ...inRules,
          }}
        />
      )}
      {["multipleSelect", "select"].includes(type) && (
        <ControlledFormSelect
          {...props}
          control={control}
          id={id}
          label={label}
          multiple={type === "multipleSelect"}
          name={name}
          options={options}
          disablePlaceholder={type === "multipleSelect"}
        />
      )}
      {type === "switch" && (
        <ControlledFormSwitch
          {...props}
          control={control}
          id={id}
          label={label}
          name={name}
        />
      )}
      {type === "text" && (
        <ControlledFormInput
          {...props}
          control={control}
          id={id}
          label={label}
          multiline={props?.rules?.multiline}
          name={name}
        />
      )}
      {type === "user" && (
        <ControlledFormSelect
          {...props}
          control={control}
          id={id}
          label={label}
          name={name}
          options={options}
        />
      )}
    </Grid>
  );
};

export { FormGrid };
